export default {
  namespaced: true,

  state: () => ({
    recentlyViewed: [],
    recommendations: [],
    slots: {}
  }),

  mutations: {
    setGallery(state, { galleryName, gallery = [] } = {}) {
      state[galleryName] = gallery;
    },
    setSlotGallery(state, { galleryName, gallery = {} } = {}) {
      state.slots[galleryName] = gallery;
    },
  },

  actions: {
    async loadRecentlyViewed({ commit }) {
      let result

      try {
        result = await this.$api.loadRecentlyViewedProducts();
      } catch(error) {
        console.error(error);
      }

      if (result?.length) {
        commit('setGallery', {
          galleryName: 'recentlyViewed',
          gallery: result,
        });
      }
    },

    async loadSlot({ commit, rootGetters }, { slot, withCategory = true } ) {
      if (!slot) {
        throw new Error('loadSlot не передан аргумент slot')
      }

      let result
      let categoryUrl = '';

      if (withCategory) {
        categoryUrl = rootGetters['category/categoryUrl'];
      }

      try {
        result = await this.$api.loadSlotProducts(slot, categoryUrl);
      } catch(error) {
        console.error(error);
      }

      if (result) {
        commit('setSlotGallery', {
          galleryName: slot,
          gallery: result[slot],
        });
      }
    },

    async loadRecommendations({ commit }, productIds = []) {
      if (!productIds.length) {
        throw new Error('loadRecommendations не передан аргумент productIds')
      }

      let result

      try {
        result = await this.$api.loadRecommendationsProducts(productIds);
      } catch(error) {
        console.error(error);
      }

      if (result?.length) {
        commit('setGallery', {
          galleryName: 'recommendations',
          gallery: result,
        });
      }
    },
  },
};
